import type {Theme} from '@emotion/react';

interface VariablesProps {
    theme: Theme;
}

/**
 * Generates CSS custom properties for base input styling.
 *
 * @param props       The properties object containing theme.
 * @param props.theme The theme object with color definitions.
 * @returns CSS string with custom properties for base input state.
 */
export const getBaseVariables = ({theme}: VariablesProps) => `
    --text-input-background-color: ${theme.colors.neutral20};
    --text-input-border-color: ${theme.colors.neutral20};
    --text-input-font-color: ${theme.colors.textPrimary};
    --text-input-placeholder-font-color: ${theme.colors.textSecondary};
    --label-font-color: ${theme.colors.textPrimary};
`;

/**
 * Generates CSS custom properties for disabled input styling.
 *
 * @param props       The properties object containing theme.
 * @param props.theme The theme object with color definitions.
 * @returns CSS string with custom properties for disabled input state.
 */
export const getDisabledVariables = ({theme}: VariablesProps) => `
    --text-input-font-color: ${theme.colors.neutral40};
    --text-input-placeholder-font-color: ${theme.colors.neutral40};
    --label-font-color: ${theme.colors.neutral60};
`;

/**
 * Generates CSS custom properties for error input styling.
 *
 * @param props       The properties object containing theme.
 * @param props.theme The theme object with color definitions.
 * @returns CSS string with custom properties for error input state.
 */
export const getErrorVariables = ({theme}: VariablesProps) => `
    --text-input-border-color: ${theme.colors.error};
    --label-font-color: ${theme.colors.textPrimary};
`;

/**
 * Generates CSS custom properties for focused input styling.
 *
 * @param props       The properties object containing theme.
 * @param props.theme The theme object with color definitions.
 * @returns CSS string with custom properties for focused input state.
 */
export const getFocusVariables = ({theme}: VariablesProps) => `
    --text-input-background-color: ${theme.colors.neutral0};
    --text-input-border-color: ${theme.colors.primary};
    --label-font-color: ${theme.colors.primary};
`;